var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M8.334 11.144H5.587L3.528 3.057c-.098-.372-.305-.701-.61-.856A8.764 8.764 0 00.4 1.345v-.312h4.424c.61 0 1.069.468 1.145 1.011l1.069 5.834 2.745-6.845h2.67l-4.12 10.111zm5.645 0h-2.594l2.136-10.11h2.594l-2.136 10.11zm5.491-7.31c.077-.544.535-.856 1.069-.856a4.713 4.713 0 012.517.467l.458-2.177A6.4 6.4 0 0021.15.8c-2.518 0-4.35 1.4-4.35 3.344 0 1.48 1.298 2.256 2.214 2.723.99.467 1.372.778 1.296 1.244 0 .7-.763 1.011-1.525 1.011-.916 0-1.832-.233-2.67-.622l-.458 2.178c.916.388 1.907.545 2.822.545 2.823.076 4.577-1.323 4.577-3.423 0-2.645-3.586-2.8-3.586-3.966zm12.663 7.31l-2.059-10.11h-2.212a1.15 1.15 0 00-1.069.777l-3.813 9.333h2.67l.533-1.477h3.28l.306 1.477h2.364zm-3.89-7.388l.762 3.81H26.87l1.373-3.81z",
    clipRule: "evenodd"
  })));
}

export default SvgLogoVisa;